export const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "O que é um Empréstimo com Garantia de Imóvel?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>O Empréstimo com Garantia de Imóvel, também conhecido como Home Equity, é um empréstimo pessoal em que você usa seu imóvel quitado como garantia e obtém benefícios como menor taxa de juros, altos valores de crédito e maiores prazos para pagar. É um empréstimo de uso livre, ou seja, você pode utilizar como desejar.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Se eu contratar o produto eu ainda continuo sendo a pessoa proprietária do imóvel?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Ao colocar o imóvel como garantia você continua sendo a pessoa proprietária do imóvel e pode utilizar o imóvel como desejar, no contrato fica uma indicação que o imóvel foi dado em garantia de uma operação de empréstimo.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Quais são os tipos de imóveis que podem ser utilizados como garantia?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Imóveis residenciais e comerciais que estejam quitados, com valor mínimo de avaliação de R$ 67 mil. Não aceitamos imóveis de terceiros como garantia, terrenos e imóveis rurais.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Quais são os valores que eu posso contratar neste empréstimo?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "O valor mínimo do Empréstimo com Garantia de Imóvel é de R$ 30 mil. Já o valor máximo é de 60% do valor do imóvel."
      }
    },
    {
      "@type": "Question",
      name: "Como são calculadas as minhas parcelas?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>O Empréstimo com Garantia de Imóvel, também conhecido como Home Equity, tem duas opções de sistemas de amortizações que você pode escolher: SAC ou Price. No sistema SAC, as primeiras parcelas são mais altas no começo e menores no final do contrato. Nessa modalidade o cálculo do juros é realizado mês a mês sobre o saldo devedor atualizado.</p><p>Já no sistema PRICE, suas parcelas são fixas, você sempre saberá o quanto vai pagar até o fim do contrato. Nessa modalidade o cálculo do juros é realizado sobre o valor total de empréstimo.</p>"
      }
    },
    {
      "@type": "Question",
      name: "O que é o sistema de amortização?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>O sistema de amortização é uma forma de redução do saldo devedor e aqui no Itaú você tem a possibilidade de escolher qual é o melhor modelo para você. Ele pode ser em parcelas iguais ou variadas. A depender do sistema escolhido, as parcelas podem ser iguais ou variadas.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Quais são os custos envolvidos na contratação de empréstimo?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Para contratar o Empréstimo com Garantia de Imóvel há custos relacionados ao IOF (Imposto sobre Operações Financeiras) e custos cartorários.</p><p>O IOF é um imposto cobrado pelo governo federal e que também incide sobre todas as operações de empréstimo. Temos a facilidade de incluir estes custos no valor do seu empréstimo, dessa forma não haverá necessidade de nenhum desembolso. Se você optar por não incluir, esses valores serão descontados no momento em que o empréstimo for liberado na sua conta corrente.</p><p>Já os custos cartorários estão relacionados ao processo de averbação do contrato, que é necessário para este tipo de operação. Esses custos deverão ser pagos diretamente com o cartório.</p><p>Haverá cobrança de Tarifa de Avaliação do Imóvel.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Qual é o prazo máximo e mínimo para parcelas o Empréstimo com Garantia de Imóvel?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>O prazo mínimo para pagamento do seu empréstimo é de 12 meses (1 ano) e o máximo é de 240 meses (20 anos).</p>"
      }
    },
    {
      "@type": "Question",
      name: "Quais documentos são necessários para contratar o Empréstimo com Garantia de Imóvel?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Para contratar o Empréstimo com Garantia de Imóvel você só precisa de 4 documentos: Documento de identificação (RG, CNH), comprovante de estado civil, IPTU e matrícula atualizada do imóvel, que deverá estar livre de ônus.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Não sou cliente, preciso abrir uma conta no Itaú para contratar esse produto?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Sim, você precisa abrir uma conta. Caso tenha interesse, abra uma conta online acessando: https://www.itau.com.br/contas/conta-corrente/</p><p>Mas lembre-se mesmo sendo cliente, após o envio da sua proposta, a mesma passará por avaliação de crédito.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Como faço para antecipar as parcelas e quitar o empréstimo?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Você pode antecipar parcelas e quitar seu empréstimo a qualquer momento, acessando seu contrato pelo bankline, falando com seu gerente ou entrando em contato com a nossa Central de Atendimento, de segunda a sexta, das 07h às 19h através dos telefones 4004-7051 (capitais e regiões metropolitanas) e  0300-789 7051  (demais regiões).</p>"
      }
    },
    {
      "@type": "Question",
      name: "Em caso de não pagamento, qual o risco de perder meu imóvel?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>O Itaú incentiva o crédito consciente e por isso faz uma análise criteriosa para avaliar sua capacidade financeira para contratar o Empréstimo com Garantia de Imóvel.</p><p>Apenas no caso de você ficar sem pagar parcelas do seu empréstimo, iniciaremos o processo de retomada do imóvel. E mesmo durante esse processo estaremos abertos a renegociação da dívida.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Qual tipo de imóvel pode ser utilizado como garantia?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Imóveis residenciais e comerciais que estejam quitados, com valor mínimo de avaliação de R$ 53 mil. Não aceitamos imóveis de terceiros, terrenos e imóveis rurais como garantia.</p>"
      }
    },
    {
      "@type": "Question",
      name: "Qual a diferença entre Empréstimo com Garantia de Imóvel e Home Equity?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p><Não há diferença. O Home Equity é um termo em inglês para definir o produto de Empréstimo com Garantia de Imóvel./p>"
      }
    },
    {
      "@type": "Question",
      name: "Quais as regras de elegibilidade do pula parcela?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<p>Ser correntista Itaú, estar em dia com o pagamento do seu contrato, não estar com processo de portabilidade em andamento, não estar utilizando o FGTS para pagamento de parte de suas parcelas no momento e não estar com o pagamento da próxima parcela já agendado, ou seja, entre a data da contratação do Pula Parcela e a data do vencimento da sua próxima parcela deve ter no mínimo 5 dias úteis de diferença.</p><p>Além disso, você não pode ter uma operação de sinistro MIP (Morte ou Invalidez Permanente) em andamento ou em processo de análise e o seu contrato tem que ter, no mínimo, mais 7 parcelas restantes.</p><p>Lembre-se que o benefício só pode ser utilizado uma vez a cada 12 meses, independente do número de parcelas que você escolheu pular, e se você tiver aderido ao programa Travessia/Carência terá que esperar, pelo menos, 12 meses a partir da data da última parcela incorporada.</p><p>Consulte se o esse benefício está disponível para você e se o seu contrato está elegível diretamente no App Itaú ;)</p>"
      }
    }
  ]
}
